import { render, staticRenderFns } from "./DrawThumb.vue?vue&type=template&id=0dac71ac&scoped=true&"
import script from "./DrawThumb.vue?vue&type=script&lang=js&"
export * from "./DrawThumb.vue?vue&type=script&lang=js&"
import style0 from "./DrawThumb.vue?vue&type=style&index=0&id=0dac71ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dac71ac",
  null
  
)

export default component.exports